export interface Manifest {
  branch: string;
  timestamp: string;
  revision: string;
}

export const loadManifest = (): Manifest => {
  const dwoManifestName = 'dwo';
  return window[dwoManifestName];
};
